import type {
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
} from 'react'

import { SENTIMENT_STATE_LABELS } from 'shared/constants/sentiment'

import type {
  SentimentIconProps,
  SentimentState,
} from './SentimentIndicator.types'
import { DecliningSentimentIcon } from './icons/DecliningSentimentIcon'
import { ImprovingSentimentIcon } from './icons/ImprovingSentimentIcon'
import { NegativeSentimentIcon } from './icons/NegativeSentimentIcon'
import { NeutralSentimentIcon } from './icons/NeutralSentimentIcon'
import { PositiveSentimentIcon } from './icons/PositiveSentimentIcon'
import type { SquircleProps } from 'hsds/components/squircle'

interface SentimentConfig {
  Icon: ForwardRefExoticComponent<
    PropsWithoutRef<SentimentIconProps> & RefAttributes<SVGSVGElement>
  >
  /** Visible text rendered next to the symbol in the `badge` type. */
  label: string
  /** HSDS Squircle color family for the `squircle` type (bg uses its 100/200 shades). */
  squircleVariant: NonNullable<SquircleProps['variant']>
}

// State → { icon component, label, squircle variant }.
export const SENTIMENT_CONFIG: Record<SentimentState, SentimentConfig> = {
  positive: {
    Icon: PositiveSentimentIcon,
    label: SENTIMENT_STATE_LABELS.positive,
    squircleVariant: 'green',
  },
  neutral: {
    Icon: NeutralSentimentIcon,
    label: SENTIMENT_STATE_LABELS.neutral,
    squircleVariant: 'charcoal',
  },
  negative: {
    Icon: NegativeSentimentIcon,
    label: SENTIMENT_STATE_LABELS.negative,
    squircleVariant: 'red',
  },
  improving: {
    Icon: ImprovingSentimentIcon,
    label: SENTIMENT_STATE_LABELS.improving,
    squircleVariant: 'blue',
  },
  declining: {
    Icon: DecliningSentimentIcon,
    label: SENTIMENT_STATE_LABELS.declining,
    squircleVariant: 'yellow',
  },
}
